/**
 * Safe redirect resolution for the registration flow.
 *
 * Returning users who reset their password should land back on the exact
 * registration form they started from. The origin is carried as a `redirect`
 * query param (modal -> forgot-password -> reset email link -> reset page).
 *
 * To prevent open-redirect abuse, only an explicit allowlist of internal
 * registration paths is honored; anything else falls back to the picker.
 */
export const REGISTRATION_REDIRECT_PATHS = [
  '/register',
  '/register/attendee',
  '/register/exhibitor',
  '/register/nps-project',
] as const;

const DEFAULT_REGISTRATION_PATH = '/register';

export function safeRegisterRedirect(value: string | null | undefined): string {
  if (!value) return DEFAULT_REGISTRATION_PATH;
  return (REGISTRATION_REDIRECT_PATHS as readonly string[]).includes(value)
    ? value
    : DEFAULT_REGISTRATION_PATH;
}
